/* eslint-disable import/no-cycle */
import axios from 'axios';

import {
  CustomException,
  getIdToken,
  // isAllResponseValid,
  isResponseValid,
  roundToTwoDecimals,
  // throwSAPError,
} from '../helpers/functions';
import i18n from '../helpers/i18nMain';
import { SET_UPLOAD_STATUS, LOAD_UPLOAD_DATA } from '../helpers/types';
import { getSortedList } from './product.actions';

const invalidResponseMsgText = 'Invalid response';
export const loadUploadExcelData = (
  enqueueSnackbar = () => {},
  filterStr = '',
  excelData,
  fileName
) => async (dispatch, getState) => {
  try {
    const state = getState();
    const { auth } = state;
    const { client, systemIP, selectedSalesOrgData, BusinessPartner } = auth;
    const { SalesOrg, DisCha, Plant, StorageLocation } = selectedSalesOrgData;

    dispatch({
      type: SET_UPLOAD_STATUS,
      payload: { isLoading: true, failText: '' },
    });
    const MainService = axios.create({
      baseURL: `${systemIP}/`,
    });

    const items = {};

    const idToken = await getIdToken(dispatch, getState);

    items.config = {
      headers: {
        'AZURE-AUTH': `${idToken}`,
      },
      params: {
        'sap-client': client,
        $filter: `SalesOrganization eq '${SalesOrg}' and DistributionChannel eq '${DisCha}'`,
      },
    };

    if (filterStr !== '') {
      items.config = {
        ...items.config,
        params: {
          ...items.config.params,
          $filter: `SalesOrganization eq '${SalesOrg}' and DistributionChannel eq '${DisCha}' and (${filterStr})`,
        },
      };
    }

    const response = await MainService.get('ZAE_PB2B_SRV/ZAE_I_Material_07', items.config);

    if (isResponseValid(response)) {
      let data = response.data.d.results;
      data = data.map(d => ({
        ...d,
        SalesPrice: undefined,
        SalesPriceUnit: undefined,
        Tax: undefined,
      }));

      const stockQuantityRequestsConfig = {
        headers: {
          'AZURE-AUTH': `${idToken}`,
          'X-Requested-With': 'XMLHttpRequest',
        },
        params: {
          'sap-client': client,
        },
      };
      const stockPriceRequestsConfig = {
        headers: {
          'AZURE-AUTH': `${idToken}`,
          'X-Requested-With': 'XMLHttpRequest',
        },
        params: {
          'sap-client': client,
        },
      };

      const qtyItemsIn = data.map(r => ({
        Material: r.Material,
        Plant,
        StorageLoc: StorageLocation,
      }));
      const stockQuantityPayload = {
        N_PB2B_GET_AVL_QTY_INPUT: qtyItemsIn,
        N_PB2B_GET_AVL_QTY_OUTPUT: [],
      };
      const priceItemsIn = data.map((r, i) => {
        let Posnr = `${(i + 1) * 10}`;
        Posnr = Posnr.padStart(6, '0');
        return {
          Posnr,
          HighItem: '000000',
          Material: r.Material,
          Plant,
        };
      });

      const stockPricePayload = {
        N_PB2B_HEADER: [
          {
            Customer: BusinessPartner,
            SalesOrg,
          },
        ],
        N_PB2B_ITEMS_IN: priceItemsIn,
        N_PB2B_ITEMS_OUT: [],
      };
      const stockQuantityResponse = await MainService.post(
        'ZAE_FM_PB2B_GET_AVL_QTY_MULTI_SRV/PB2B_GET_AVL_QTY_INPUTSet',
        stockQuantityPayload,
        stockQuantityRequestsConfig
      ).catch(err => console.log(err));

      const stockPriceResponse = await MainService.post(
        'ZAE_FM_PB2B_SIMULATE_GET_PRICE_SRV/ZAE_FM_PB2B_SIMULATE_GET_PRICESet',
        stockPricePayload,
        stockPriceRequestsConfig
      ).catch(err => console.log(err));

      data = data.map(d => {
        let dF = d;
        try {
          const stockResults =
            stockQuantityResponse !== undefined
              ? stockQuantityResponse.data.d.N_PB2B_GET_AVL_QTY_OUTPUT.results
              : [];
          if (stockResults.length > 0) {
            const fD = stockResults.find(s => s.Material === dF.Material);
            dF = {
              ...dF,
              checked: false,
              ConditionQuantity: '1',
              ConditionQuantityUnit: 'EA',
              StockQuantity: parseInt(fD.AvlQty, 10),
              StockQuantityUOM: fD.Uom,
            };
          } else {
            dF = {
              ...dF,
              checked: false,
              ConditionQuantity: '1',
              ConditionQuantityUnit: 'EA',
              StockQuantity: undefined,
              StockQuantityUOM: undefined,
            };
          }
          return dF;
        } catch (err) {
          return dF;
        }
      });
      data = data.map(d => {
        let dF = d;
        try {
          const priceResults = stockPriceResponse.data.d.N_PB2B_ITEMS_OUT.results;
          if (priceResults.length > 0) {
            const pD = priceResults.find(s => s.Material === dF.Material);
            dF = {
              ...dF,
              checked: false,
              ConditionQuantity: pD.ReqQty,
              ConditionQuantityUnit: pD.SalesUnit,
              SalesPrice: roundToTwoDecimals(pD.GrossPrice),
              SalesPriceUnit: pD.Currency, // TODO: Get Currency from Price FM
              Tax: pD.Tax,
            };
          } else {
            dF = {
              ...dF,
              checked: false,
              ConditionQuantity: '1',
              ConditionQuantityUnit: 'EA',
              SalesPrice: undefined,
              SalesPriceUnit: undefined,
              Tax: undefined,
            };
          }
          return dF;
        } catch (err) {
          return dF;
        }
      });
      let uploadData = excelData.map(eL => {
        let tD = data.find(
          d =>
            d.Material &&
            d.Material.toString() === eL.Material.toString() &&
            d.SalesPrice &&
            d.SalesPrice > 0 &&
            d.StockQuantity !== undefined &&
            d.StockQuantity &&
            d.StockQuantity >= eL.ConditionQuantity
        );
        if (tD !== undefined) {
          tD = {
            ...tD,
            ConditionQuantity: eL.ConditionQuantity,
            ConditionQuantityUnit: tD.ConditionQuantityUnit,
            ConditionRateValue: tD.SalesPrice,
            ConditionRateValueUnit: tD.SalesPriceUnit,
            Availablity: true,
            AvailableStock: true,
            checked: false,
            StockQuantity: tD.StockQuantity,
          };
        } else {
          tD = {
            ...eL,
            Material: eL.Material.toString(),
            ConditionQuantity: eL.ConditionQuantity,
            ConditionQuantityUnit: undefined,
            ConditionRateValue: undefined,
            ConditionRateValueUnit: undefined,
            Availablity: false,
            AvailableStock: false,
            checked: false,
          };
        }
        return tD;
      });

      uploadData = uploadData.map(l => ({
        ...l,
        subTotal: l.SalesPrice !== undefined ? l.SalesPrice * l.ConditionQuantity : undefined,
      }));
      data = getSortedList(uploadData);

      dispatch({
        type: LOAD_UPLOAD_DATA,
        payload: uploadData,
      });
      enqueueSnackbar(
        `${i18n.t('uploadScreenTranslations:FILE')} ${fileName} ${i18n.t(
          'uploadScreenTranslations:UPLOAD_SUCC'
        )}`,
        {
          variant: 'success',
        }
      );
    } else {
      throw new CustomException(invalidResponseMsgText);
    }
  } catch (error) {
    enqueueSnackbar(i18n.t('uploadScreenTranslations:UNABLE_TO_LOAD_UPLOAD_DATA'), {
      variant: 'error',
    });
    dispatch({
      type: SET_UPLOAD_STATUS,
      payload: {
        isLoading: false,
        failText: i18n.t('uploadScreenTranslations:UNABLE_TO_LOAD_UPLOAD_DATA'),
      },
    });
  }
};

export const resetUploadData = uploadData => {
  return {
    type: LOAD_UPLOAD_DATA,
    payload: uploadData,
  };
};
